<template>
  <v-dialog
    v-model="open"
    max-width="700"
    scrollable
  >
    <v-card>
      <v-card-title>
        Add employee
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 450px;" class="pt-4">
        <v-row no-gutters>
          <v-col cols="6" class="px-1">
            <v-text-field
              v-model="candidate.employee_id"
              label="Employee id *"
              name="employee id"
              outlined
              dense
              :error-messages="errors.collect('employee id')"
              v-validate="{ required: true, regex: /^[-a-zA-Z0-9. ]+$/ }"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="First name *"
              name="first name"
              v-model="candidate.first_name"
              outlined
              dense
              :error-messages="errors.collect('first name')"
              v-validate="'required|alpha_spaces|max:30'"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Last name *"
              name="last name"
              dense
              v-model="candidate.last_name"
              outlined
              :error-messages="errors.collect('last name')"
              v-validate="'required|alpha_spaces|max:30'"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Email *"
              name="email"
              v-model="candidate.email"
              outlined
              dense
              :error-messages="errors.collect('email')"
              v-validate="'required|email'"
            ></v-text-field>
            <div class="phone-error" style="margin-top:-24px; margin-bottom:5px;" v-if="!isEmailValid">Employee email is invalid!</div>
          </v-col>
          <v-col cols="6" class="px-1">
            <vue-tel-input
              class="pb-1 emp-phone-field"
              :class="!phoneIsValid ? 'ph-error' : ''"
              v-model="candidate.phoneNumber"
              @country-changed="countrySelected"
              @input="onInput"
              name="phone number"
              placeholder="Phone number"
            ></vue-tel-input>
            <div class="mb-2">
              <!-- <div class="phone-error" v-if="phoneIsBlank">The phone number field is required</div> -->
              <div class="phone-error" v-if="!phoneIsValid">The phone number field format is invalid</div>
            </div>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-select
              :items="list.gender"
              v-model="candidate.gender"
              name="gender"
              :error-messages="errors.collect('gender')"
              label="Gender *"
              item-text="title"
              v-validate="'required'"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-menu
              v-model="joinDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Joining date *"
                  outlined
                  dense
                  @input="changeFormat()"
                  v-validate="'required'"
                  name="joining date"
                  :error-messages="errors.collect('joining date')"
                  v-model="candidate.joining_date "
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="candidate.joining_date " @input="joinDateMenu = false, changeFormat()">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Location *"
              name="location"
              :error-messages="errors.collect('location')"
              v-model="candidate.location"
              v-validate="{ required: true, regex: /^[-a-zA-Z0-9., ]+$/ }"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Department *"
              v-model="candidate.department"
              outlined
              name="department"
              dense
              :error-messages="errors.collect('department')"
              v-validate="{ required: true, regex: /^[-a-zA-Z0-9. ]+$/ }"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-autocomplete
              :items="user.language_mappings"
              item-text="name"
              item-value="language_code"
              label="Preferred language"
              outlined
              dense
              name="preferred_lang"
              v-model="candidate.language_code"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div class="pb-4 heading black--text">Other fields</div>
        <v-row no-gutters>
          <v-col cols="6" class="px-1">
            <v-menu
              v-model="birthDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Birth date"
                  outlined
                  dense
                  hide-details
                  @input="changeFormatDOB()"
                  v-validate="'date_format:dd-mm-yyyy'"
                  name="birth date"
                  :error-messages="errors.collect('birth date')"
                  v-model="candidate.birthDate"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="primary"
                v-model="candidate.birthDate"
                @input="checkAge(candidate.birthDate);changeFormatDOB();birthDateMenu = false;"
              ></v-date-picker>
            </v-menu>
            <div class="mb-2">
              <!-- <div class="phone-error" v-if="phoneIsBlank">The phone number field is required</div> -->
              <div class="phone-error" v-if="!isDOBValid">Employee age should be above 18 years</div>
            </div>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Alternate email"
              outlined
              dense
              name="alternate email"
              :error-messages="errors.collect('alternate email')"
              v-validate="'email'"
              v-model="candidate.alternateEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Education"
              outlined
              dense
              name="education"
              :error-messages="errors.collect('education')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.education"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Experience"
              name="experience"
              outlined
              dense
              :error-messages="errors.collect('experience')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.experience"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Designation"
              v-model="candidate.designation"
              outlined
              name="designation"
              dense
              :error-messages="errors.collect('designation')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Grade"
              outlined
              name="grade"
              dense
              :error-messages="errors.collect('grade')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.grade"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Sub department"
              outlined
              name="sub department"
              dense
              :error-messages="errors.collect('sub department')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.sub_department"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Manager"
              outlined
              name="manager"
              dense
              :error-messages="errors.collect('manager')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.manager"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Function"
              outlined
              name="function"
              dense
              :error-messages="errors.collect('function')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.function"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Business"
              outlined
              dense
              name="business"
              :error-messages="errors.collect('business')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.business"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Team"
              outlined
              name="team"
              dense
              :error-messages="errors.collect('team')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.team"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Business head"
              outlined
              name="business head"
              dense
              :error-messages="errors.collect('business head')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.businessHead"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="Team head"
              outlined
              name="team head"
              dense
              :error-messages="errors.collect('team head')"
              v-validate="{ regex: /^[-a-zA-Z0-9. ]+$/ }"
              v-model="candidate.teamHead"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              label="HRBP"
              outlined
              dense
              name="hrbp"
              :error-messages="errors.collect('hrbp')"
              v-validate="'email'"
              v-model="candidate.hrbp"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-menu
              ref="shiftStartTime"
              v-model="shiftStartTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="candidate.shiftStartTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="candidate.shiftStartTime"
                  label="Shift start time"
                  prepend-inner-icon="lar la-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="shiftStartTimeMenu"
                v-model="candidate.shiftStartTime"
                full-width
                @click:minute="$refs.shiftStartTime.save(candidate.shiftStartTime);shiftStartTimeMenu = false;"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-menu
              ref="shiftEndTimeMenu"
              v-model="shiftEndTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="candidate.shiftEndTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="candidate.shiftEndTime"
                  label="Shift end time"
                  prepend-inner-icon="lar la-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="shiftEndTimeMenu"
                v-model="candidate.shiftEndTime"
                full-width
                @click:minute="$refs.shiftEndTimeMenu.save(candidate.shiftEndTime);shiftEndTimeMenu = false;"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-menu
              v-model="exitDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Exit date"
                  outlined
                  dense
                  v-model="candidate.exit_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="candidate.exit_date" @input="exitDateMenu = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-select
              :items="list.hiPos"
              v-model="candidate.high_potential_emp"
              name="hipo"
              label="High potential employee"
              item-text="title"
              class="elevation-0 grey--text text--lighten-2"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          text
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="white--text"
          @click="validateAll()"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
// import { ContentLoader } from 'vue-content-loader';
import axios from 'axios';

export default {
  name: 'UploadSingleEmployee',
  // components: {
  //   ContentLoader
  // },
  data () {
    return {
      isEmailValid: true,
      whitelistError: '',
      joinDateMenu: false,
      open: false,
      dateFormatted: '',
      phone: null,
      countryCode: null,
      phoneIsValid: true,
      // phoneIsBlank: false,
      list: {
        gender: [{
          title: 'Male',
          value: 'male'
        }, {
          title: 'Female',
          value: 'female'
        }, {
          title: 'Other',
          value: 'other'
        }, {
          title: 'Not Disclosed',
          value: 'notDisclosed'
        }],
        types: [{
          title: 'Manager',
          value: 'manager'
        }, {
          title: 'Team Employee',
          value: 'staff'
        }],
        hiPos: [
          {
            title: 'True',
            value: 1
          },
          {
            title: 'False',
            value: 0
          }
        ]
      },
      candidate: {
        first_name: '',
        last_name: '',
        email: '',
        phoneNumber: '',
        type: 'staff',
        sub_type: 'staff',
        gender: ''
      },
      isDOBValid: true,
      shiftStartTimeMenu: false,
      shiftEndTimeMenu: false,
      exitDateMenu: false,
      birthDateMenu: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    checkAge (date) {
      const fData = dayjs(date).format('DD/MM/YYYY');
      this.isDOBValid = false;
      var parts = fData.split('/');
      var dtDOB = new Date(parts[1] + '/' + parts[0] + '/' + parts[2]);
      var dtCurrent = new Date();
      if (dtCurrent.getFullYear() - dtDOB.getFullYear() < 17) {
        this.isDOBValid = false;
      }
      if (dtCurrent.getFullYear() - dtDOB.getFullYear() === 17) {
        if (dtCurrent.getMonth() < dtDOB.getMonth()) {
          this.isDOBValid = false;
        }
        if (dtCurrent.getMonth() === dtDOB.getMonth()) {
          if (dtCurrent.getDate() < dtDOB.getDate()) {
            this.isDOBValid = false;
          }
        }
      }
      if (dtCurrent.getFullYear() - dtDOB.getFullYear() > 17) {
        this.isDOBValid = true;
      }
    },
    countrySelected (val) {
      this.countryCode = val.dialCode;
    },
    onInput (number, isValid) {
      if (isValid.isValid) {
        this.phoneIsValid = true;
        // this.phoneIsBlank = false;
        this.candidate.phoneNumber = isValid.number.e164;
      } else {
        this.phoneIsValid = false;
      }
    },
    validateAll () {
      if (!this.candidate.phoneNumber) {
        // this.phoneIsBlank = true;
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (!this.phoneIsValid) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Fields necessary, Please resolve all the errors!'
            });
            return;
          }
          if (this.isDOBValid) {
            this.save();
          }
          if (!this.isDOBValid) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Eligibility 18 years old only!'
            });
          }
        } else {
          if (!this.contactSales.contact_phone || this.contactSales.contact_phone === '') {
            this.phoneIsValid = false;
          }
          this.$store.dispatch('updateSnackbar', {
            color: 'info',
            show: true,
            text: 'Fields necessary, Please resolve all the errors!'
          });
        }
      });
    },
    save () {
      axios.post(`${process.env.VUE_APP_API_URL}users/bulk_add`, {
        user_data: [this.candidate]
      }).then((response) => {
        this.refreshing = false;
        if (response && response.data && response.data.status === 200 &&
        (!response.data.Failed_list || response.data.Failed_list.length === 0)) {
          this.$store.dispatch('updateSnackbar', {
            color: 'info',
            show: true,
            text: 'Employee uploaded!'
          });
          this.open = false;
          this.closeDialog();
        } else if (response.data.Failed_list && response.data.Failed_list.length > 0) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: response.data.Failed_list[0].validation_error
          });
          if (response.data.Failed_list[0].validation_error.split('[')[1] === '"Employee email invalid: ') {
            this.isEmailValid = false;
            this.whitelistError = response.data.Failed_list[0].validation_error;
          }
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to upload employee, Please try again later!'
          });
        }
      }, (response) => {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to upload employee, Please try again later!'
        });
        throw new Error(response);
      });
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    changeFormat () {
      // if (this.candidate.joining_date) {
      //   const [year, month, day] = this.candidate.joining_date.split('-');
      //   this.candidate.joining_date = `${day}-${month}-${year}`;
      // }
    },
    changeFormatDOB () {
      if (this.candidate.birthDate) {
        const [year, month, day] = this.candidate.birthDate.split('-');
        this.candidate.birthDate = `${day}-${month}-${year}`;
      }
    },
    closeDialog () {
      this.candidate = {
        first_name: '',
        last_name: '',
        email: '',
        phoneNumber: '',
        type: 'staff',
        sub_type: 'staff',
        gender: ''
      };
      this.errors.clear();
      this.open = false;
    }
  },
  watch: {
    // candidate () {
    //   if (this.candidate.joining_date) {
    //     this.candidate.joining_date = this.formatDate(this.candidate.joining_date);
    //     console.log(this.candidate.joining_date);
    //   }
    // }
  },
  beforeMount () {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.emp-phone-field {
  border-radius: 8px !important;
  &.ph-error {
    border: 2px solid red;
    ::-webkit-input-placeholder {
      color: red !important;
    }
  }
}
.phone-error {
  font-size: 12px;
  color: red;
}
</style>
